import { useEffect, useRef, useState } from 'react';
import { IOfferAction } from '@models/winnerSelection/ITableDemand';
import { WinnerSelectionService } from '@services/WinnerSelectionService';
import AttachmentsArchiveModal from '@molecules/AttachmentsArchiveWait/AttachmentsArchiveModal';
import { createAttachmentsArchiveTask } from '@molecules/AttachmentsArchiveWait/attachmentsArchiveTask';
import { offerAttachmentsUrl } from './downloadOfferAttachments';

const DEFAULT_HEADER = 'Скачать документацию';

export interface IOfferAttachmentsArchiveProps {
    tableKey: string;
    offerKey: string;
    action: IOfferAction;
    onClose: () => void;
}

/** Окно сборки архива документации предложения фоновой задачей; фона на сервере нет — файл сразу, окно закрывается. */
const OfferAttachmentsArchive = ({ tableKey, offerKey, action, onClose }: IOfferAttachmentsArchiveProps) => {
    const close = useRef(onClose);
    useEffect(() => {
        close.current = onClose;
    }, [onClose]);
    const [task] = useState(() =>
        createAttachmentsArchiveTask(
            () => WinnerSelectionService.startOfferAttachmentsInBackground(offerKey, tableKey, action.key),
            {
                syncUrl: offerAttachmentsUrl(offerKey, tableKey, action.key),
                onSyncDownload: () => close.current(),
            },
        ),
    );

    return <AttachmentsArchiveModal header={action.displayName || DEFAULT_HEADER} task={task} onClose={onClose} />;
};

export default OfferAttachmentsArchive;
